<template>
  <div class="flex-grow flex items-center select-none w-0 overflow-hidden mr-1">
    <input
      v-show="showInput"
      ref="inputRef"
      autocorrect="off"
      autocomplete="off"
      autocapitalize="off"
      spellcheck="false"
      type="text"
      :class="['palette-' + palette]"
      class="w-0 h-[29px] bg-black-50 flex-grow border-[1px] border-black outline-none pl-[5px] leading-[12px]"
      @focus="focus"
      @blur="blur"
      @keyup="keyup"
    />
    <div
      v-show="!showInput"
      class="px-[6px] flex-grow flex-shrink whitespace-nowrap overflow-ellipsis overflow-hidden mt-[1px]"
      @dblclick="edit"
    >
      {{ text }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, nextTick } from 'vue';

const props = withDefaults(
  defineProps<{
    text?: string;
    palette?: 'red' | 'blue';
  }>(),
  {
    text: '图层名',
    palette: 'blue'
  }
);

const emit = defineEmits<{
  (event: 'submit', value: string): void;
}>();

const inputRef = ref<HTMLInputElement>();
const showInput = ref(false);

function edit(e?: MouseEvent) {
  if (e && (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey)) return;

  showInput.value = true;

  nextTick(() => {
    if (inputRef.value) {
      inputRef.value.value = props.text;
      inputRef.value.focus();
    }
  });
}

function focus() {
  inputRef.value?.setSelectionRange(0, inputRef.value.value.length);
}

function blur() {
  if (inputRef.value?.value) {
    emit('submit', inputRef.value.value);
  }

  setTimeout(() => {
    showInput.value = false;
  }, 20);
}

function keyup(e: KeyboardEvent) {
  if (e.key === 'Enter') {
    inputRef.value?.blur();
  }
}

defineExpose({
  edit,
  showInput
});
</script>

<style scoped>
.palette-blue::selection {
  color: #c2ddfb;
  background: #2559c9;
}

.palette-red::selection {
  color: #cb97ff;
  background: #4a5878;
}
</style>
